import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  Table,
  Alert,
  Switch,
  Input,
  message,
  Popconfirm,
  Button,
  Collapse,
  Form,
  Select,
} from "antd";
import PropTypes from "prop-types";
import {
  req_list_lrs_equipment,
  req_add_lrs_equipment,
  req_delete_lrs_equipment,
  req_edit_lrs_equipment,
  req_list_lrs_site,
} from "../../api";
import { usrRole } from "../../utils/dataUtil";

const { Panel } = Collapse;
const { Option } = Select;
class EquipmentModalConfig extends Component {
  state = {
    loading: false,
    item: null,
    items: [],
    subitems: [],
    space: {},
    editMode: true,
    setEquipmentName: "",
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
    this.api_list_subitems();
  }

  componentDidMount() {
    this.api_list_items();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const { RoomCode } = this.props.space;
    const result = await req_list_lrs_equipment(
      userLevel,
      userCode,
      RoomCode,
      token
    );
    if (result.total) {
      const items = result.total > 0 ? result.data : [];
      this.setState({ items });
    }
  };

  api_list_subitems = async () => {
    const { token, userCode, role } = this.props.user;
    const { RoomCode } = this.props.space;
    var userLevel = usrRole(role);
    const result = await req_list_lrs_site(
      userLevel,
      userCode,
      RoomCode,
      token
    );
    if (result.total) {
      const subitems = result.total > 0 ? result.data : [];
      // items.forEach((element) => {
      //   if (element.SpaceSiteNId === SpaceSiteNId) {
      //     element.chooseStatus = "Y";
      //   }
      //   element.SpaceSiteNId = element.SpaceSiteNId.toString();
      // });
      this.setState({ subitems });
    }
    //console.log(result);
  };

  api_add_item = async (item) => {
    //console.log(item);
    const { token } = this.props.user;
    const result = await req_add_lrs_equipment(item, token);
    if (result.status === "success") {
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };

  api_del_item = async (item) => {
    //console.log(item);
    const { Uid } = item;
    const { token } = this.props.user;
    const result = await req_delete_lrs_equipment(Uid, token);
    if (result.status === "success") {
      message.info(result.message);
      this.api_list_items();
    } else {
      message.info(result.message);
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    //console.log(item);
    const result = await req_edit_lrs_equipment(item, token);
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "狀態",
        width: 20,
        render: (item) => {
          const { EquipmentStatus } = item;
          return (
            <>
              <Switch
                checkedChildren="正常"
                unCheckedChildren="異常"
                defaultChecked={EquipmentStatus === "NORMAL" ? true : false}
                onChange={(e) => this.handle_switch_change(e, item)}
              />
            </>
          );
        },
      },
      {
        title: "資產編號",
        dataIndex: "EquipmentCode",
        width: 20,
      },
      {
        title: "名稱",
        width: 50,
        responsive: ["md"],
        render: (item) => {
          const { EquipmentName } = item;
          const { editMode } = this.state;
          return (
            <>
              <Input
                className="form-control"
                placeholder="請輸入設備名稱"
                disabled={editMode === true ? false : true}
                style={{
                  backgroundColor:
                    editMode === true ? "LightYellow" : "LightGray",
                }}
                defaultValue={EquipmentName}
                onChange={(e) => this.handle_input_change(e.target.value, item)}
              />
            </>
          );
        },
      },
      {
        title: "操作",
        width: 30,
        render: (item) => {
          const { subitems } = this.state;
          const { SiteTotal } = item;
          return (
            <>
              <Popconfirm
                title="確定要刪除此筆設備"
                onConfirm={() => this.handle_show_ui_modal("DELETE", item)}
              >
                <Button type="primary">
                  <i className="fa fa-minus-circle"></i>
                  <span style={{ marginLeft: "4px" }}>刪除</span>
                </Button>
              </Popconfirm>
              {SiteTotal > 0 ? (
                <>
                  <Select
                    defaultValue={item.SpaceSiteNId.toString()}
                    onChange={(value) => this.handle_select_change(value, item)}
                  >
                    {subitems.length > 0 ? (
                      <>
                        <Option value="0">未指定位置</Option>
                        {subitems.map((subitem) => (
                          <Option
                            key={subitem.SpaceSiteNId.toString()}
                            value={subitem.SpaceSiteNId.toString()}
                          >
                            {subitem.SiteName}
                          </Option>
                        ))}
                      </>
                    ) : (
                      ""
                    )}
                  </Select>
                </>
              ) : (
                ""
              )}
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_add_item = (item) => {
    this.api_add_item(item);
  };

  handle_delete_item = (item) => {
    this.api_del_item(item);
  };

  handle_edit_item = (condition, item) => {
    item.condition = condition;
    this.api_modify_item(item);
  };

  handle_input_change(value, item) {
    const { Uid } = item;
    const obj = {
      condition: "BASE",
      EquipmentName: value,
      Uid: Uid,
    };
    this.handle_edit_item("BASE", obj);
  }

  handle_select_change(value, item) {
    console.log(value);
    console.log(item);
    const row = {
      Uid: item.Uid,
      SpaceSiteNId: value,
      condition: "SITE",
    };
    this.api_modify_item(row);
  }

  handle_switch_change(checked, item) {
    const { Uid } = item;
    const EquipmentStatus = checked === false ? "NORMAL" : "ABNORMAL";
    const obj = {
      condition: "STATUS",
      EquipmentStatus: EquipmentStatus,
      Uid: Uid,
    };
    this.handle_edit_item("STATUS", obj);
  }

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "ADD":
        this.setState({ isShowAddModal: true });
        break;
      // case "EDIT":
      //   this.setState({ isShowEditModal: true });
      //   break;
      case "DELETE":
        //console.log(item);
        const target = {
          Uid: item.Uid,
          condition: "GUID",
        };
        this.handle_delete_item(target);
        break;
      case "CONFIG_SITE":
        this.setState({ isShowModal: true });
        break;
      default:
    }
    this.setState({ item: item });
  };

  handle_form_finish = (values) => {
    const { EquipmentCode, EquipmentName } = values;
    const { RoomCode } = this.props.space;
    //console.log(values);
    const item = {
      RoomCode: RoomCode,
      EquipmentCode: EquipmentCode,
      EquipmentName: EquipmentName,
      EquipmentStatus: "NORMAL",
    };
    this.api_add_item(item);
  };

  //////////////////////////////////////////////////////////

  render() {
    const { loading, items } = this.state;
    const { RoomCode, RoomTwName } = this.props.space;
    return (
      <Card>
        <div>
          <Alert
            message={
              <div style={{ color: "red", fontSize: "1.3em" }}>
                ({RoomCode}){RoomTwName}
              </div>
            }
            type="success"
          />
        </div>
        <Collapse accordion>
          <Panel
            header={
              <>
                <i className="fa fa-plus-square"></i> 新增設備
              </>
            }
            key="1"
          >
            <Form layout={"inline"} onFinish={this.handle_form_finish}>
              <Form.Item
                label="資產編號"
                name="EquipmentCode"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="請輸入資產編號" />
              </Form.Item>
              <Form.Item
                label="名稱"
                name="EquipmentName"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="請輸入設備名稱" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  <i className="fa fa-plus-circle"></i>{" "}
                  <span style={{ marginLeft: "4px" }}>新增</span>
                </Button>
              </Form.Item>
            </Form>
          </Panel>
        </Collapse>
        <Table
          dataSource={items}
          columns={this.columns}
          loading={loading}
          rowKey="Uid"
          scroll={{ y: 460 }}
          width="70%"
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(EquipmentModalConfig);
